import React from "react";
import { UsersTable } from "../components";
import { hooks } from "../../../utils";
import { api } from "../../../services";
import { Spacing } from "../../../config";
import { CircularProgress } from "@material-ui/core";
import Styles from "../styles/Styles";
import { errorModal } from "../../../components/modals/utils";

function Container() {
  const { loading, call } = hooks.useRequest();
  const [usersListData, setUsersListData] = React.useState<any>({});
  const [pageNumber, setPageNumber] = React.useState<any>(1);
  const [pageSize, setPageSize] = React.useState<any>(5);
  const FilterData = React.useRef<any>();

  const Mount = React.useCallback(() => {
    errorModal.setInfos("Carregando", ["aguarde..."], null, null);
    call(
      "UsersTable",
      api.GetUserAll({ page: 0, size: pageSize, admin: true }),
      async (response) => {
        if (response.ok) {
          let newList = [] as any;
          for (const item of response?.data?.content) {
            if (item.imageId !== null && item.imageId !== undefined) {
              await call(null, api.getImage(item.id), (response) => {
                newList.push({ ...item, img: response?.data });
              });
            } else {
              newList.push({ ...item, img: null });
            }
          }
          setUsersListData({ ...response.data, content: newList });
          setPageNumber(1);
        }
      }
    );
  }, []);
  React.useEffect(Mount, [Mount]);

  const getSelectedFilterTable = (selectedFilter) => {
    errorModal.setInfos("Carregando", ["aguarde..."], null, null);
    call(
      "UsersTable",
      api.GetUserAll({
        page: 0,
        size: pageSize,
        filter: selectedFilter,
        admin: true,
      }),
      async (response) => {
        if (response.ok) {
          let newList = [] as any;
          for (const item of response?.data?.content) {
            if (item.imageId !== null && item.imageId !== undefined) {
              await call(null, api.getImage(item.id), (response) => {
                newList.push({ ...item, img: response?.data });
              });
            } else {
              newList.push({ ...item, img: null });
            }
          }
          setUsersListData({ ...response.data, content: newList });
        }
      }
    );
  };

  const GetPage = (newPage: number, newPageSize?: any) => {
    errorModal.setInfos("Carregando", ["aguarde..."], null, null);
    if (newPageSize) {
      setPageSize(newPageSize);
    }
    call(
      "UsersTable",
      api.GetUserAll({
        page: newPage - 1,
        size: newPageSize ? newPageSize : pageSize,
        filter: FilterData.current,
        admin: true,
      }),
      async (response) => {
        if (response.ok) {
          let newList = [] as any;
          for (const item of response?.data?.content) {
            if (item.imageId !== null && item.imageId !== undefined) {
              await call(null, api.getImage(item.id), (response) => {
                newList.push({ ...item, img: response?.data });
              });
            } else {
              newList.push({ ...item, img: null });
            }
          }
          setUsersListData({ ...response.data, content: newList });
          setPageNumber(newPage);
        }
      }
    );
  };

  return (
    <>
      {loading ? (
        <Styles.LoadingContainer>
          <CircularProgress
            size={120}
            style={{
              color: "black",
              alignSelf: "center",
              justifyContent: "center",
              marginBlock: Spacing(3),
            }}
          />
        </Styles.LoadingContainer>
      ) : (
        <UsersTable
          size={pageSize}
          tableData={usersListData}
          page={pageNumber}
          setPage={GetPage}
          loadTable={Mount}
          loading={loading}
          sendSelectedFilter={getSelectedFilterTable}
          filterValue={FilterData}
        />
      )}
    </>
  );
}

export default Container;
